

// export default {
//     name: "Agent DB CMS",
//     path: "/agent/cms",
//     meta: {
//         icon: "speaker_notes",
//         auth: true
//     },
//     departmentName: "Agent DB CMS",
//     finalPagePermision: "Agent DB CMS",

//     component: require("../component/agentDash/agentCmsDash.vue")
// };

export default {
    name: "Agent DB CMS",
    meta: {
        icon: "directions_boat",
        expanded: true,
        auth: true,
    },
    departmentName: "Agent DB CMS",
    finalPagePermision: "Agent DB CMS",
    children: [{
        name: "Agent FF DB CMS",
        path: "/agent/cms",
        permissionName: 'Agent DB CMS',
        keywords: ['Agent FFCon DB CMS', 'Agent FF DB CMS'],
        meta: {
            icon: "directions_boat",
            auth: true,
        },
        component: require("../component/agentDash/agentCmsDash.vue"),
        finalPagePermision: "Agent DB CMS",
    },
    {
        name: "Agent FFCon DB CMS",
        path: "/agent/consol-cms",
        permissionName: 'Agent DB CMS',
        keywords: ['Agent FFCon DB CMS', 'Agent FF DB CMS'],
        meta: {
            icon: "directions_boat",
            auth: true,
        },
        component: require("../component/agentDash/agentCmsConsoleDash.vue"),
        finalPagePermision: "Agent DB CMS",
    },
    
    ],
};


// WEBPACK FOOTER //
// ./src/sidebar/agentCmsDash.js